import React from "react";

const ComingSoonPage = () => {
    return (
        <div className="coming-soon-container">
            <h1>Coming Soon</h1>
            <p>We are working hard to bring you something awesome!</p>
            <p>Stay tuned for updates.</p>
        </div>
    );
};

export default ComingSoonPage;
